module.exports = __webpack_public_path__ + "img/_1.3a7af961.png";